import { Router } from '@angular/router';
import { PreloaderService } from './../../../common/services/preloader/preloader.service';
import { AppInjector } from './../../../app-injector';
import { ApiService } from './../../../api/api.service';
import { API_CALL_ERROR } from './../../../store/action';
import { call, put, takeEvery, takeLatest, fork, select } from 'redux-saga/effects';
import * as _ from 'lodash';
import { ReflectiveInjector, Injector } from '@angular/core';
import {
  FETCH_DESTINATIONS_REQUESTED,
  FETCH_DESTINATIONS_SUCCEEDED,
  DELETE_DESTINATION_REQUESTED,
  FETCH_ALL_INVENTORY_OF_DESTINATION_REQUESTED,
  DELETE_DESTINATION_SUCCEEDED
} from './list.action';
import { Exception } from '../../../common/exceptions/exception';
import { NotificationService } from '../../../common/services/notification/notification.service';

function* fetchDestinations(action) {
  try {
    const api = AppInjector.get(ApiService);
    let results = yield api.destination.get(action.data).toPromise();
    yield put({ type: FETCH_DESTINATIONS_SUCCEEDED, data: results.items, pagination: results.pagination });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchDestinationRequested() {
  yield takeEvery(FETCH_DESTINATIONS_REQUESTED, fetchDestinations);
}

function* deleteDestination(action) {
  const api = AppInjector.get(ApiService);
  try {
    AppInjector.get(PreloaderService).show();
    let result = yield api.destination.delete(action.data).toPromise();
    if (!_.isUndefined(action.com)) {
      AppInjector.get(Router).navigate(['destination']);
    } else {
      yield put({ type: DELETE_DESTINATION_SUCCEEDED, data: result });
    }
    AppInjector.get(PreloaderService).hide();
  } catch (e) {
    AppInjector.get(PreloaderService).hide();
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchDeleteDestinationRequest() {
  yield takeEvery(DELETE_DESTINATION_REQUESTED, deleteDestination);
}

function* watchDeleteDestinationSUCCEEDED() {
  yield takeEvery(DELETE_DESTINATION_SUCCEEDED, function*() {
    yield put({ type: FETCH_DESTINATIONS_REQUESTED });
  });
}

function* fetchInventoryOfDestination(action) {
  const api = AppInjector.get(ApiService);
  try {
    let results = yield api.inventory.list(action.data).toPromise();
    if (!_.isEmpty(results)) {
      AppInjector.get(NotificationService).show('warning', `Could not delete this destination. There are ${results.length} remaining products in this.`, 5000);
      throw new Exception('Could not delete this destination. There is remaining products in this.');
    }
    if (confirm('Do you want to delete this destination?')) {
      yield put({ type: DELETE_DESTINATION_REQUESTED, data: action.data.constraints.destination_id });
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchAllInventoryOfDestinationRequest() {
  yield takeEvery(FETCH_ALL_INVENTORY_OF_DESTINATION_REQUESTED, fetchInventoryOfDestination);
}

export default [watchFetchDestinationRequested, watchDeleteDestinationRequest, watchDeleteDestinationSUCCEEDED, watchFetchAllInventoryOfDestinationRequest];
